import React from "react";
import CssBaseline from "@mui/material/CssBaseline";

function HeaderPublic(props) {
    return (<>
        <div id="header">
            <CssBaseline />
        </div>
    </>);
}

export default HeaderPublic;
